// test246
(246 && 0);
